module.exports = __webpack_public_path__ + "img/jump-up.35cd746b.svg";